import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import acc from 'accounting'
import {TopButtonPointAction} from "../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class OrlenTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

            wszystkieKolumnyEksport: [
                {value: "ID", label: 'ID'},
                {value: "DataTransakcji", label: 'Data transakcji'},
                {value: "Miejscowosc", label: 'Miejscowość'},
                {value: "IDStacji", label: 'ID Stacji'},
                {value: "IDStacjiOperator", label: 'ID Stacji Operator'},
                {value: "NumerFaktury", label: 'Numer faktury'},
                {value: "NumerKarty", label: 'Numer karty'},
                {value: "Imie", label: 'Imie'},
                {value: "Nazwisko", label: 'Nazwisko'},
                {value: "KatPojazdu", label: 'Kat pojazdu'},
                {value: "MPK", label: 'MPK'},
                {value: "NumerRej", label: 'Numer rejestracji'},
                {value: "LicznikKM", label: 'Licznik KM'},
                {value: "NazwaProduktu", label: 'Nazwa produktu'},
                {value: "JM", label: 'JM'},
                {value: "Cena", label: 'Cena'},
                {value: "VAT", label: 'VAT'},
                {value: "PobranaIlosc", label: 'Pobrana ilość'},
                {value: "Wartosc", label: 'Wartość'},
                {value: "DaneDodatkowe", label: 'Dane dodatkowe'},
                {value: "DaneKosztowe", label: 'Dane kosztowe'},
                {value: "EAN", label: 'EAN'},
                {value: "GrProdukut", label: 'Gr produktu'},
                {value: "IDFloty", label: 'ID Floty'},
                {value: "KodWalutyLocOperator", label: 'Kod waluty loc operator'},
            ],
            kolumnyDoExportuDefault: [
                {value: "DataTransakcji", label: 'Data transakcji'},
                {value: "Miejscowosc", label: 'Miejscowość'},
                {value: "IDStacji", label: 'ID Stacji'},
                {value: "IDStacjiOperator", label: 'ID Stacji Operator'},
                {value: "NumerFaktury", label: 'Numer faktury'},
                {value: "NumerKarty", label: 'Numer karty'},
                {value: "NumerRej", label: 'Numer rejestracji'},
                {value: "LicznikKM", label: 'Licznik KM'},
                {value: "NazwaProduktu", label: 'Nazwa produktu'},
                {value: "JM", label: 'JM'},
                {value: "Cena", label: 'Cena'},
                {value: "VAT", label: 'VAT'},
                {value: "PobranaIlosc", label: 'Pobrana ilość'},
                {value: "Wartosc", label: 'Wartość'},
                {value: "DaneDodatkowe", label: 'Dane dodatkowe'},
                {value: "DaneKosztowe", label: 'Dane kosztowe'},
            ]

        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction onClick={() => {
                }} buttonIcon={'fa fa-list'} buttonColor={'default'} titleContent={'Zobacz pozycje'}/>
            </div>
        )
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };
        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                    Ilość wszystkich logów: {this.props.data.length}
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover

                    >
                        <TableHeaderColumn dataField='ID' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='NumerFaktury' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Nr faktury</TableHeaderColumn>
                        <TableHeaderColumn dataField='DataTransakcji' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Data i godzina transakcji</TableHeaderColumn>
                        <TableHeaderColumn dataField='Miejscowosc' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Miejscowość</TableHeaderColumn>
                        <TableHeaderColumn dataField='Imie' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Imie</TableHeaderColumn>
                        <TableHeaderColumn dataField='NumerKarty' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Nr karty</TableHeaderColumn>
                        <TableHeaderColumn dataField='NumerRej' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Nr rejestracji</TableHeaderColumn>
                        <TableHeaderColumn dataField='LicznikKM' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Licznik KM</TableHeaderColumn>
                        <TableHeaderColumn dataField='NazwaProduktu' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Produkt</TableHeaderColumn>
                        <TableHeaderColumn dataField='JM' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >JM</TableHeaderColumn>
                        <TableHeaderColumn dataField='Cena' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Cena</TableHeaderColumn>
                        <TableHeaderColumn dataField='PobranaIlosc' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Ilość</TableHeaderColumn>
                        <TableHeaderColumn dataField='Wartosc' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Wartość</TableHeaderColumn>
                        {/*<TableHeaderColumn dataField='ID'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       dataFormat={this.renderButtonyAkcji}
                    >Zobacz pozycje</TableHeaderColumn>*/}
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/Orlen/components/OrlenTable.js